import React, { useEffect, useState, useRef } from "react";
import { WhstappGalleryList } from "../api/Api";
import pdf from "../assets/img/pdf.png";
import { userloginDetails } from "../../Utils/AdminAuth";

const MediaSelector = ({
  isOpen,
  onClose,
  selectedMedia,
  onSelectMedia,
  // userId,
  // token,
  mediaOptionSelected,
  setMediaOptionSelected,
  gotoMediaPage,
}) => {
  const [medialist, setMediaList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const copyTimerRef = useRef(null);
  const itemsPerPage = 8;

  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;

  useEffect(() => {
    if (!isOpen) return;

    let paramData = {
      user_id: userId,
      method: "retrieve",
      token: userToken
    }
    WhstappGalleryList(paramData).then((res) => {
      const allData = res?.data?.data || [];

      const extMap = {
        image: ["png", "jpg", "jpeg"],
        video: ["mp4", "mp3"],
        document: ["pdf"],
      };

      const filtered = Array.isArray(allData)
        ? allData.filter((item) => {
          const ext = item.doc_url?.split(".").pop().toLowerCase();
          return extMap[mediaOptionSelected]?.includes(ext);
        })
        : [];


      setMediaList(filtered);
    });
  }, [mediaOptionSelected, isOpen]);

  const totalPages = Math.ceil(medialist.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = medialist.slice(startIndex, startIndex + itemsPerPage);

  const handleSelect = (url) => {
    onSelectMedia(url, medialist);
    onClose();
  };

  const handleCopyUrl = (e, url, index) => {
    e.stopPropagation();
    navigator.clipboard.writeText(url).then(() => {
      setCopiedIndex(index);
      clearTimeout(copyTimerRef.current);
      copyTimerRef.current = setTimeout(() => setCopiedIndex(null), 2000);
    });
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        paddingTop: "20px",
      }}
    >
      <div
        className="modal-dialog"
        style={{
          maxWidth: "70%",
          width: "70%",
          margin: "auto",
        }}
      >
        <div className="modal-content">
          <div className="modal-header py-2 px-3">
            <h6 className="modal-title mb-0">Choose Media</h6>
            <button type="button" className="close" onClick={onClose}>
              <span style={{ fontSize: "1.5rem" }}>&times;</span>
            </button>
          </div>

          <div className="modal-body pt-2 pb-1 px-3">
            <nav className="text-center">
              <ol
                className="breadcrumb bg-transparent p-0 mb-2"
                style={{ cursor: "pointer" }}
              >
                {["image", "video", "document"].map((type) => (
                  <li
                    key={type}
                    onClick={() => {
                      setMediaOptionSelected(type);
                      setCurrentPage(1);
                    }}
                    className={`breadcrumb-item ${mediaOptionSelected === type ? "active" : ""
                      }`}
                  >
                    {type.charAt(0).toUpperCase() + type.slice(1)}s
                  </li>
                ))}
              </ol>
            </nav>

            <div className="row">
              {currentItems.map((item, index) => (
                <div
                  key={index}
                  className="col-6 col-sm-4 col-md-3 mb-2"
                  onClick={() => handleSelect(item.doc_url)}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className={`card h-100 ${selectedMedia === item.doc_url ? "border-primary" : ""
                      }`}
                    style={{ fontSize: "12px" }}
                  >
                    {item.doc_url.match(/\.(jpeg|jpg|png|gif|webp)$/i) ? (
                      <img
                        src={item.doc_url}
                        alt={item.doc_name}
                        className="card-img-top"
                        style={{
                          height: "100px",
                          width: "100%",
                          objectFit: "contain",
                          padding: "5px",
                        }}
                      />
                    ) : item.doc_url.match(/\.(mp4|webm|ogg)$/i) ? (
                      <video
                        src={item.doc_url}
                        controls
                        className="card-img-top"
                        style={{
                          height: "100px",
                          width: "100%",
                          objectFit: "contain",
                          padding: "5px",
                        }}
                      />
                    ) : (
                      <div
                        className="card-img-top d-flex align-items-center justify-content-center bg-light"
                        style={{ height: "100px", padding: "15px" }}
                      >
                        <img
                          src={pdf}
                          alt={item.doc_name}
                          style={{
                            maxHeight: "50px",
                            width: "auto",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    )}
                    <div className="card-body py-1 px-2">
                      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <p
                          className="card-text text-truncate mb-0"
                          title={item.doc_name}
                          style={{ fontSize: "11px", flex: 1, minWidth: 0 }}
                        >
                          {item.doc_name}
                        </p>
                        <button
                          onClick={(e) => handleCopyUrl(e, item.doc_url, startIndex + index)}
                          title="Copy URL"
                          style={{
                            flexShrink: 0,
                            border: "1px solid #dee2e6",
                            borderRadius: "4px",
                            background: copiedIndex === startIndex + index ? "#d1fae5" : "#f8f9fa",
                            color: copiedIndex === startIndex + index ? "#065f46" : "#6c757d",
                            cursor: "pointer",
                            padding: "1px 5px",
                            fontSize: "10px",
                            lineHeight: 1.4,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {copiedIndex === startIndex + index ? "Copied!" : "Copy URL"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="modal-footer d-flex justify-content-between px-2 py-1">
            <button
              className="btn btn-outline-dark btn-sm px-2 py-1"
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              style={{ fontSize: "12px" }}
            >
              Previous
            </button>
            <div style={{ fontSize: "11px", paddingTop: "2px" }}>
              Page {currentPage} of {totalPages}
            </div>
            <button
              className="btn btn-outline-dark btn-sm px-2 py-1"
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages}
              style={{ fontSize: "12px" }}
            >
              Next
            </button>
          </div>

          <div className="modal-footer py-1 px-2">
            <button
              className="btn btn-info btn-sm px-3 py-1"
              onClick={gotoMediaPage}
              style={{ fontSize: "12px" }}
            >
              Upload New
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaSelector;
